// prettier-ignore
export default "fr"